<template>

    <div id="layout-console" class="cms">
        <transition name="modal">
            <v-modal-feedback v-if="showModal === 'feedback'" />
            <v-modal-logout v-if="showModal === 'logout'" />
            <v-modal-company-create v-if="showModal === 'company-create'" />
        </transition>
        <v-the-alerts />
        <div class="cms-sidebar">
            <v-the-sidebar />
        </div>
        <div class="cms-primary">
            <router-view></router-view>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .cms {
        background: $color-bg;
        display: flex;
        min-width: $screen-xl-min;
        min-height: 100%;
        .cms-sidebar {
            background: $color-text;
            flex-shrink: 0;
            position: relative;
            width: $sidebar-width;
            z-index: 10;
        }
        .cms-primary {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            position: relative;
        }
    }

</style>

<script>

import ModalCompanyCreate from '@modals/company/ModalCompanyCreate';
import ModalFeedback from '@modals/misc/ModalFeedback';
import ModalLogout from '@modals/misc/ModalLogout';
import PusherUtil from '@utils/PusherUtil';
import TheAlerts from '@cmp/TheAlerts';
import TheSidebar from '@cmp/TheSidebar';

export default {

    components: {
        'v-modal-company-create': ModalCompanyCreate,
        'v-modal-feedback': ModalFeedback,
        'v-modal-logout': ModalLogout,
        'v-the-alerts': TheAlerts,
        'v-the-sidebar': TheSidebar,
    },

    computed: {

        user() {
            return this.$store.getters.user;
        },

    },

    mounted() {
        // Connect to Pusher.
        PusherUtil.connect(this.$store.getters.apiKey);

        // Hide Recaptcha.
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.hideBadge();
        }
        window.addEventListener('load', () => {
            this.$recaptchaInstance.hideBadge();
        });

        // HelpScout init.
        if (this.user.has_chat_widget) {
            this.initHelpScout();
        }

        // Request for push notifications.
        window.cp('push');
    },

    watch: {

        user(newValue, oldValue) {
            if (newValue.has_chat_widget && !oldValue.has_chat_widget) {
                this.initHelpScout();
            } else if (!newValue.has_chat_widget && oldValue.has_chat_widget) {
                window.Beacon('destroy');
            }
        },

    },

    methods: {

        initHelpScout() {
            window.Beacon('init', process.env.VUE_APP_HELPSCOUT_KEY);
            window.Beacon('identify', {
                user_id: this.user.id,
                email: this.user.email,
                name: this.user.name,
            });
        },

    },

}

</script>